import React from 'react';
import {useState, useEffect} from "react";
import {useParams, /* Link, */useNavigate} from 'react-router-dom';
import {
	parseDateISOString,
	formatDate /*, 
	getWeekReport,
	getProject, 
	getDateCaption */
} from "./apiService";
import {
	getEntries as bigtimeGetEntries /*,
	addEntry as bigtimeAddEntry,
	deleteEntry as bigtimeDeleteEntry */
} from "./bigtimeService"

const BigtimeEntries = props => {
	// const [error, setError] = useState(null);
	// const [isLoaded, setIsLoaded] = useState(false);
    const [entries, setEntries] = useState([]);
	const params = useParams();
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
	console.log('BigtimeEntries params', params);
	useEffect(() => {
		console.log('BigtimeEntries useEffect', params);
		let tmpStartDate = parseDateISOString(params.startDate);
		let tmpEndDate = parseDateISOString(params.endDate);
        if(tmpStartDate == null) {
            tmpStartDate = new Date(2021, 3, 4, 6);
        }
        if(tmpEndDate == null) {
            tmpEndDate = new Date();
        }
        setStartDate(tmpStartDate);
        setEndDate(tmpEndDate);
        bigtimeGetEntries(tmpStartDate, tmpEndDate, "Detailed").then(data => {
			console.log('bigtimeGetEntries data', data);
            setEntries(data);
        }, error => {
           console.log('bigtimeGetEntries error', error); 
        });
    }, [params, navigate]);

    console.log('entries', entries);
    console.log('startDate', startDate);
    console.log('endDate', endDate);
    entries.sort((e1, e2) => {
        if(e1.Dt < e2.Dt) {
            return -1;
        }
        if(e1.Dt > e2.Dt) {
            return 1;
        }
        return 0;
    });
    let dates = [];
    let curDate = null;
    let dateHours = 0;
    let index = 0;
    let totalOver = 0;
    let entryIndex = 0;
    let getHoursPerWeek = date => {
        return date.getTime() >= new Date(2020, 4, 3, 6).getTime() ? 30 : 40;
    };
    for(let entry of entries) {
        // new Date with string that includes the time will be evaluated in local time zone
        let tmpDate = new Date(new Date(entry.Dt + " 00:00:00").getTime());
        // console.log("entry date", entry.Dt, tmpDate);
        // set date to previous sunday
		tmpDate.setDate(tmpDate.getDate() /* day of month */ - tmpDate.getDay() /* day of week */);
        if(curDate == null || curDate.getTime() !== tmpDate.getTime()) {
            if(curDate != null) {
                let over = dateHours - getHoursPerWeek(curDate);
                dates.push({"index": index, "date": curDate, "hours": dateHours, "over": over});
                totalOver += over;
            }
            curDate = tmpDate;
            dateHours = 0;
            index++;
        }
        dateHours += +entry.Hours_IN;
        entry.index = entryIndex++;
    }
    if(curDate != null) {
        let over = dateHours - getHoursPerWeek(curDate);
        dates.push({"index": index, "date": curDate, "hours": dateHours, "over": over});
        totalOver += over;
    }
    let projectMap = {};
    let addTask = (entry) => {
        // entry.ProjectSID, entry.TaskSID, entry.ProjectNm, +entry.Hours_IN
        let projectSID = entry.ProjectSID;
        let projectName = entry.ProjectNm;
        let taskSID = entry.TaskSID;
        let taskName = entry.TaskNm;
        let hours = entry.Hours_IN;
        let mappedProject = projectMap[projectSID];
        if(mappedProject == null) {
            mappedProject = {};
            projectMap[projectSID] = mappedProject;
        }
        let mappedTask = mappedProject[taskSID];
        if(mappedTask == null) {
            mappedTask = {hours: 0};
            mappedProject[taskSID] = mappedTask;
        }
        mappedTask.projectSID = projectSID;
        mappedTask.taskSID = taskSID;
        mappedTask.projectName = projectName;
        mappedTask.taskName = taskName;
        mappedTask.hours += hours;
        mappedTask.index = 0;
    };
    for(let entry of entries) {
        addTask(entry);
    }
    let tasks = [];
    for(let projectSID in projectMap) {
        let mappedProject = projectMap[projectSID];
        for(let taskSID in mappedProject) {
            let mappedTask = mappedProject[taskSID];
            tasks.push(mappedTask);
            mappedTask.index = tasks.length;
        }
    }
    tasks.sort((t1, t2) => {
        if(t1.projectName < t2.projectName) {
            return -1;
        }
        if(t1.projectName > t2.projectName) {
            return 1;
        }
        if(t1.taskName < t2.taskName) {
            return -1;
        }
        if(t1.taskName > t2.taskName) {
            return 1;
        }
        return 0;
    });
    let formattedStartDate = formatDate(startDate);
    let formattedEndDate = formatDate(endDate);
    let weekSection = [];
    console.log(startDate, formattedStartDate);
    weekSection.push(<>
        <h2>Weeks</h2>
        </>);
    let trinetStartDate = new Date(2021, 3, 4, 6);
    if(startDate != null && startDate.getTime() >= trinetStartDate.getTime()) {
        weekSection.push(<>
            Excess charged to CGI: 23.5<br/>
            Excess charged to CAP week of 12/23/2024: 7.0<br/>
            Paid weeekend time MWD 10/12-10/13: 10<br/>
            Balance from Netsuite: 18.25<br/>
            Total over: {totalOver} - 23.5 - 7 - 10 + 18.25 = {totalOver-23.5-7-10+18.25}
            </>);
    }
    weekSection.push(<>
        <table className="bigtime-week-hours">
            <thead>
                <tr>
                    <th>Date</th>
                    <th style={{textAlign: "right"}}>Hours</th>
                    <th style={{textAlign: "right"}}>Over</th>
                </tr>
            </thead>
            <tbody>
            {
                dates.map(dateObj => {
                    return (
                        <>
                        <tr key={dateObj.index}>
                            <td>{formatDate(dateObj.date)}</td>
                            <td style={{textAlign: "right"}}>{dateObj.hours}</td>
                            <td style={{textAlign: "right"}}>{dateObj.hours - getHoursPerWeek(dateObj.date)}</td>
                        </tr>
                        </>
                    )
                })
            }
            </tbody>
        </table>
        </>);
    return (
    <>
    <h1>Bigtime Entries Report</h1>
    {formattedStartDate} to {formattedEndDate}
    {weekSection}
    <h2>Summary</h2>
    <table className="bigtime-summary">
        <thead>
            <tr>
                <th>Project Name</th>
                <th>Task Name</th>
                <th>Hours</th>
            </tr>
        </thead>
        <tbody>
            {
                tasks.map(task => {
                    return (
                        <tr key={task.index}>
                            <td>{task.projectName}</td>
                            <td>{task.taskName}</td>
                            <td style={{textAlign: "right"}}>{task.hours}</td>
                        </tr>
                    );
                })
            }
        </tbody>
    </table>
    <h2>Details</h2>
    <table className="bigtime-entries">
        <thead>
            <tr>
                <th></th>
                <th>Date</th>
                <th>Project Name</th>
                <th>Task Name</th>
                <th>Notes</th>
                <th style={{textAlign: "right"}}>Hours</th>
            </tr>
        </thead>
        <tbody>
            {
                entries.map(entry => {
                    return (
                        <tr key={entry.index}>
                            <td>{entry.IsNew ? 'new' : ''}</td>
                            <td style={{whiteSpace: "nowrap", paddingRight: "10px"}}>{entry.Dt}</td>
                            <td>{entry.ProjectNm}</td>
                            <td>{entry.TaskNm}</td>
                            <td>{entry.Notes}</td>
                            <td style={{textAlign: "right"}}>{entry.Hours_IN}</td>
                        </tr>
                    )
                })
            }
        </tbody>
    </table>
    </>
    );
};

export default BigtimeEntries;